//#region src/transaction_user_action.ts
var TransactionUserAction = /* @__PURE__ */ function(TransactionUserAction) {
	TransactionUserAction[TransactionUserAction["None"] = 0] = "None";
	TransactionUserAction[TransactionUserAction["Cancelled"] = 1] = "Cancelled";
	TransactionUserAction[TransactionUserAction["Abandoned"] = 2] = "Abandoned";
	return TransactionUserAction;
}(TransactionUserAction || {});
//#endregion
export { TransactionUserAction };

//# sourceMappingURL=transaction_user_action.js.map